<template>
  <section class="viewsrhqyBasicManage_BookingStrandedWarning">
    <viewTitle title="业务管理 / 基础数据管理 / 逗留预警配置" :showReturn="false" />

    <section class="controler">
      <div class="ctrLeft" style="width: 100%;">
        <el-button
          v-has="['c-base-data-warning-mgr']"
          type="primary"
          size="small"
          @click="openCreateDialog"
        >
          新增配置
        </el-button>
        <el-button type="primary" size="small" @click="refreshData">刷新数据</el-button>
      </div>
    </section>

    <section class="main-table">
      <el-table
        v-if="showTable"
        :max-height="tableMaxSize"
        style="width: 100%;"
        show-overflow-tooltip
        :data="tableData"
        header-cell-class-name="table-header-cell"
        header-row-class-name="table-header-row"
        cell-class-name="table-cell"
        :border="true"
        empty-text="暂无逗留预警配置"
      >
        <el-table-column prop="business_name" label="预约业务" min-width="180" />
        <el-table-column prop="warning_scene_name" label="预警场景" width="120" />
        <el-table-column label="预警级别" min-width="360">
          <template slot-scope="scope">
            <div
              v-for="(rule, ruleIndex) in scope.row.receiver_config || []"
              :key="`${scope.row.id}-${ruleIndex}`"
              class="rule-display-line"
            >
              <span class="rule-time">{{ rule.over_time }}分钟</span>
              <span class="rule-arrow">-></span>
              <span>{{ formatRuleUsers(resolveRuleDisplayUsers(rule)) || "--" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            {{ scope.row.state === 1 ? "生效" : "不生效" }}
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="170">
          <template slot-scope="scope">
            {{ formatTime(scope.row.update_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope)">编辑</el-button>
            <el-button
              v-if="scope.row.id"
              v-has="['c-base-data-warning-mgr']"
              type="text"
              @click="remove(scope)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <el-dialog
      :title="form.id ? '编辑逗留预警配置' : '新增逗留预警配置'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :show-close="false"
      class="dialogClass"
      width="56%"
    >
      <el-form ref="form" :model="form" label-width="96px">
        <el-form-item label="预约业务">
          <el-select
            v-model="form.business_id"
            clearable
            filterable
            placeholder="请选择预约业务"
            style="width: 100%;"
            @change="onBusinessChange"
          >
            <el-option
              v-for="item in businessOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="预警场景">
          <el-select v-model="form.warning_scene" placeholder="请选择预警场景" style="width: 100%;">
            <el-option
              v-for="item in warningSceneOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio v-model="form.state" :label="1">生效</el-radio>
          <el-radio v-model="form.state" :label="2">不生效</el-radio>
        </el-form-item>
        <el-form-item label="预警级别">
          <section
            v-for="(rule, ruleIndex) in form.receiver_config"
            :key="rule.key"
            class="rule-edit-card"
          >
            <div class="rule-edit-header">
              <span>第{{ ruleIndex + 1 }}级</span>
              <el-button
                v-if="form.receiver_config.length > 1"
                type="text"
                class="rule-remove-btn"
                @click="removeRule(ruleIndex)"
              >
                删除级别
              </el-button>
            </div>

            <el-form-item label="超时时间" label-width="96px" class="rule-edit-item">
              <el-input v-model="rule.over_time" placeholder="请输入分钟数，最小5分钟">
                <template slot="append">分钟</template>
              </el-input>
            </el-form-item>

            <el-form-item label="推送给" label-width="96px" class="rule-edit-item">
              <tableSelector
                :title="'请选择推送人员'"
                v-model="rule.user_ids"
                :rows.sync="rule.user_list"
                :columns="userColumns"
                :params="rule.selector_params"
                :http-request="userLoad"
                @close="onCloseSelector(rule)"
              >
                <div class="mb-4" slot="search">
                  <el-input
                    v-model="rule.selector_params.keyword"
                    class="w-60"
                    clearable
                    placeholder="搜索账号、手机号和联系人"
                  />
                  <span style="margin-left: 10px;">角色：</span>
                  <el-select
                    v-model="rule.selector_params.role_id"
                    multiple
                    clearable
                    placeholder="请选择角色"
                  >
                    <el-option
                      v-for="item in baseRoleList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </div>
                <div slot="content">
                  <span v-if="rule.user_list.length > 0 || rule.user_display_list.length > 0">
                    {{ formatRuleUsers(resolveRuleDisplayUsers(rule)) }}
                  </span>
                </div>
                <el-link type="primary" :underline="false">请选择人员</el-link>
              </tableSelector>
            </el-form-item>
          </section>

          <el-button plain size="small" class="rule-add-btn" @click="appendRule">新增级别</el-button>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-has="['c-base-data-warning-mgr']" type="primary" @click="saveConfig">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
import { mapGetters } from "vuex";
import viewTitle from "@/components/viewTitle";
import tableSelector from "@/components/tableSelector/index.vue";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";

export default {
  // 关键步骤：页面和后端统一维护最小超时时间，避免出现前后端校验口径不一致。
  minWarningOverTimeMinutes: 5,
  components: {
    viewTitle,
    tableSelector
  },
  mixins: [mixinTableLyout],
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      form: this.createEmptyForm(),
      businessOptions: [],
      warningSceneOptions: [
        { value: "OUTSIDE", label: "厂外" },
        { value: "INSIDE", label: "厂内" }
      ],
      userColumns: [
        { label: "联系人", prop: "contact" },
        { label: "账号", prop: "account" },
        { label: "角色", prop: "role_name" }
      ]
    };
  },
  computed: {
    ...mapGetters(["baseRole"]),
    baseRoleList() {
      const roleList = Array.isArray(this.baseRole) ? this.baseRole : [];
      return roleList.filter(e => {
        const insider = ["admin", "sampler", "sample_receiver", "stevedore", "gate_guard"].includes(e.code);
        const isCustom = e.code.indexOf("custom-") === 0;
        return insider || isCustom;
      });
    }
  },
  created() {
    this.initPage();
  },
  methods: {
    // 初始化页面基础数据。
    async initPage() {
      await Promise.all([this.getBusinessOptions(), this.getList()]);
    },
    // 构造人员选择器的独立筛选条件，避免多个级别共用同一份筛选状态。
    createEmptySelectorParams() {
      return {
        keyword: "",
        role_id: []
      };
    },
    // 构造空级别规则，统一新增和重置逻辑。
    createEmptyReceiverRule() {
      return {
        key: `${Date.now()}-${Math.random()}`,
        over_time: "",
        user_ids: [],
        user_list: [],
        user_display_list: [],
        selector_params: this.createEmptySelectorParams()
      };
    },
    // 构造空表单，统一新增和重置逻辑。
    createEmptyForm() {
      return {
        id: "",
        business_id: "",
        business_name: "",
        warning_scene: "INSIDE",
        state: 1,
        receiver_config: [this.createEmptyReceiverRule()]
      };
    },
    // 归一化后端返回的级别规则。
    normalizeReceiverConfig(receiverConfig) {
      const rules = Array.isArray(receiverConfig) ? receiverConfig : [];
      if (rules.length === 0) {
        return [this.createEmptyReceiverRule()];
      }
      return rules.map(rule => ({
        key: `${Date.now()}-${Math.random()}`,
        over_time: rule.over_time || "",
        user_ids: rule.user_ids || [],
        user_list: rule.user_list || [],
        user_display_list: rule.user_display_list || [],
        selector_params: this.createEmptySelectorParams()
      }));
    },
    // 加载列表数据。
    async getList() {
      const dataObj = await this.$common.http({
        url: "/api/queue/admin/query_config_warning_list",
        data: {}
      });
      this.tableData = (dataObj.data.data || []).map(item => ({
        ...item,
        warning_scene: item.warning_scene || "INSIDE",
        warning_scene_name: item.warning_scene_name || this.getWarningSceneLabel(item.warning_scene),
        receiver_config: this.normalizeReceiverConfig(item.receiver_config || [])
      }));
    },
    // 加载预约业务下拉选项。
    async getBusinessOptions() {
      const dataObj = await this.$common.http({
        url: "/api/queue/admin/query_business",
        data: {
          state: 1,
          keyword: ""
        }
      });
      const list = dataObj.data.data || [];
      this.businessOptions = Array.isArray(list)
        ? list.map(item => ({
            id: item.id,
            name: item.name
          }))
        : [];
    },
    // 刷新列表。
    refreshData() {
      this.initPage();
    },
    // 打开新增配置弹窗。
    openCreateDialog() {
      this.form = this.createEmptyForm();
      this.dialogVisible = true;
    },
    // 打开编辑弹窗。
    edit(scope) {
      const row = cloneDeep(scope.row);
      this.form = {
        id: row.id || "",
        business_id: row.business_id || "",
        business_name: row.business_name || "",
        warning_scene: row.warning_scene || "INSIDE",
        state: row.state || 1,
        receiver_config: this.normalizeReceiverConfig(row.receiver_config || [])
      };
      this.dialogVisible = true;
    },
    // 新增一级预警规则。
    appendRule() {
      this.form.receiver_config.push(this.createEmptyReceiverRule());
    },
    // 删除指定级别规则。
    removeRule(index) {
      this.form.receiver_config.splice(index, 1);
    },
    // 选择预约业务后同步名称。
    onBusinessChange(value) {
      const targetOption = this.businessOptions.find(item => item.id === value);
      this.form.business_name = targetOption ? targetOption.name : "";
    },
    // 统一格式化预警场景名称。
    getWarningSceneLabel(warningScene) {
      return warningScene === "OUTSIDE" ? "厂外" : "厂内";
    },
    // 格式化时间。
    formatTime(str) {
      if (!str) return "--";
      const year = Number(moment(Number(str) * 1000).format("YYYY"));
      return moment().year() === year
        ? moment(Number(str) * 1000).format("MM月DD日 HH:mm")
        : moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
    },
    // 格式化接收人名称。
    formatRuleUsers(list) {
      return (list || [])
        .map(e => e.display_name || e.name || e.contact)
        .filter(Boolean)
        .join("；");
    },
    // 优先使用和当前选择一致的展示列表，避免编辑后仍显示旧手机号缓存。
    resolveRuleDisplayUsers(rule) {
      const userList = Array.isArray(rule.user_list) ? rule.user_list : [];
      const userDisplayList = Array.isArray(rule.user_display_list) ? rule.user_display_list : [];
      if (userDisplayList.length === 0) {
        return userList;
      }

      const userListIds = userList.map(item => String(item.id || ""));
      const userDisplayIds = userDisplayList.map(item => String(item.id || ""));
      if (
        userListIds.length === userDisplayIds.length
        && userListIds.every((id, index) => id === userDisplayIds[index])
      ) {
        return userDisplayList;
      }

      return userList;
    },
    // 归一化超时时间输入，兼容输入法下的全角数字和首尾空格。
    normalizeOverTimeValue(value) {
      return String(value == null ? "" : value)
        .trim()
        .replace(/[０-９]/g, word => String.fromCharCode(word.charCodeAt(0) - 65248));
    },
    // 判断超时时间是否为正整数。
    isPositiveIntegerOverTime(value) {
      return /(^[1-9]\d*$)/.test(this.normalizeOverTimeValue(value));
    },
    // 获取页面允许配置的最小超时时间，统一和后端校验口径。
    getMinWarningOverTimeMinutes() {
      return this.$options.minWarningOverTimeMinutes || 5;
    },
    // 校验“预约业务 + 场景”组合是否重复。
    validateDuplicateSceneConfig() {
      const duplicateItem = this.tableData.find(item => {
        if (item.id && this.form.id && item.id === this.form.id) {
          return false;
        }
        return item.business_id === this.form.business_id && item.warning_scene === this.form.warning_scene;
      });
      if (duplicateItem) {
        this.$common.pcToastFail("同一预约业务下预警场景不能重复");
        return false;
      }
      return true;
    },
    // 校验并归一化级别规则。
    validateReceiverConfig() {
      if (!this.form.receiver_config || this.form.receiver_config.length === 0) {
        this.$common.pcToastFail("请至少配置一条逗留预警级别");
        return null;
      }

      let prevOverTime = 0;
      const overTimeMap = {};
      const normalizedRules = [];
      for (const rule of this.form.receiver_config) {
        const normalizedOverTime = this.normalizeOverTimeValue(rule.over_time);
        if (!this.isPositiveIntegerOverTime(normalizedOverTime)) {
          this.$common.pcToastFail("超时时间只能为正整数");
          return null;
        }

        const overTime = Number(normalizedOverTime);
        if (overTime < this.getMinWarningOverTimeMinutes()) {
          this.$common.pcToastFail("超时时间最小为5分钟");
          return null;
        }
        if (overTimeMap[overTime]) {
          this.$common.pcToastFail("超时时间不能重复");
          return null;
        }
        if (overTime <= prevOverTime) {
          this.$common.pcToastFail("超时时间必须按从小到大排序");
          return null;
        }
        if (!rule.user_ids || rule.user_ids.length === 0) {
          this.$common.pcToastFail("推送人员不能为空");
          return null;
        }

        normalizedRules.push({
          over_time: normalizedOverTime,
          user_ids: rule.user_ids
        });
        overTimeMap[overTime] = true;
        prevOverTime = overTime;
      }

      return normalizedRules;
    },
    // 保存配置。
    async saveConfig() {
      if (!this.form.business_id) {
        this.$common.pcToastFail("请选择预约业务");
        return;
      }
      if (!this.form.warning_scene) {
        this.$common.pcToastFail("请选择预警场景");
        return;
      }
      if (!this.validateDuplicateSceneConfig()) {
        return;
      }

      const receiverConfig = this.validateReceiverConfig();
      if (!receiverConfig) {
        return;
      }

      const api = this.form.id ? "/api/queue/admin/update_config_warning" : "/api/queue/admin/add_config_warning";
      const resp = await this.$common.http({
        url: api,
        data: {
          id: this.form.id,
          business_id: this.form.business_id,
          warning_scene: this.form.warning_scene,
          state: this.form.state,
          receiver_config: receiverConfig
        }
      });
      if (resp.data.errcode === 0) {
        this.dialogVisible = false;
        this.getList();
      } else {
        this.$common.pcToastFail(resp.data.errmsg);
      }
    },
    // 删除配置。
    remove(scope) {
      this.$confirm("确认删除该逗留预警配置？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const resp = await this.$common.http({
          url: "/api/queue/admin/delete_config_warning",
          data: { id: scope.row.id }
        });
        if (resp.data.errcode === 0) {
          this.getList();
        } else {
          this.$common.pcToastFail(resp.data.errmsg);
        }
      });
    },
    // 关闭人员选择器时清空筛选条件。
    onCloseSelector(rule) {
      // 每个级别单独重置自己的筛选条件，避免关闭一个弹窗时影响其他级别。
      rule.selector_params = this.createEmptySelectorParams();
    },
    // 加载人员选择器数据。
    async userLoad(params) {
      const defaultRoleId = this.baseRoleList.map(e => e.id).join(",");
      const dataObj = await this.$common.http({
        url: "/api/contact/search",
        data: {
          ...params,
          role_id:
            params.role_id && params.role_id.length > 0
              ? params.role_id.join(",")
              : defaultRoleId,
          is_select: 1,
          limit: params.page_size,
          offset: (params.page - 1) * params.page_size,
          type: 2
        }
      });
      return {
        data: dataObj.data.data.items,
        total: dataObj.data.data.total
      };
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/common";

.viewsrhqyBasicManage_BookingStrandedWarning {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;

  .controler {
    display: flex;
    margin-bottom: 16px;
  }

  .main-table {
    width: 100%;
  }

  .rule-display-line {
    display: flex;
    align-items: center;
    line-height: 24px;
  }

  .rule-time {
    min-width: 70px;
    color: #1f2937;
  }

  .rule-arrow {
    margin: 0 8px;
    color: #9ca3af;
  }

  .rule-edit-card {
    padding: 12px 12px 2px;
    margin-bottom: 12px;
    background: #f8fafc;
    border: 1px solid #dbe4ee;
    border-radius: 8px;
  }

  .rule-edit-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    font-weight: 600;
    color: #1f2937;
  }

  .rule-remove-btn {
    padding: 0;
  }

  .rule-edit-item {
    margin-bottom: 12px;
  }

  .rule-add-btn {
    width: 100%;
  }
}
</style>

<style lang="less">
.viewsrhqyBasicManage_BookingStrandedWarning {
  .dialogClass {
    .el-dialog__body {
      max-height: 600px;
      overflow-y: auto;
    }
  }
}
</style>
